<template>
  <div v-if="fields.length > 0" class="bg-gray-50 rounded-xl p-4 space-y-4">
    <div class="flex items-center gap-2 mb-1">
      <svg class="w-4 h-4 text-gray-400" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M12 2L2 7l10 5 10-5-10-5z"/><path d="M2 17l10 5 10-5"/><path d="M2 12l10 5 10-5"/></svg>
      <span class="text-sm font-semibold text-gray-700">Custom Attributes</span>
    </div>

    <div v-for="field in fields" :key="field._id">
      <!-- Text -->
      <template v-if="field.type === 'text'">
        <label class="block text-sm font-medium text-gray-600 mb-1.5">{{ field.name }}</label>
        <input type="text" v-model="field.value" @change="emitUpdated" :placeholder="field.name" />
      </template>

      <!-- Number -->
      <template v-if="field.type === 'number'">
        <label class="block text-sm font-medium text-gray-600 mb-1.5">{{ field.name }}</label>
        <input type="number" v-model="field.value" @change="emitUpdated" :placeholder="field.name" />
      </template>

      <!-- Boolean -->
      <template v-if="field.type === 'boolean'">
        <div class="flex items-center justify-between py-1">
          <div>
            <p class="text-sm font-medium text-gray-700">{{ field.name }}</p>
            <p class="text-xs text-gray-400">{{ field.code }}</p>
          </div>
          <ToggleSwitch v-model="field.value" @update:model-value="emitUpdated" />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import api from '../services/api.js'
import ToggleSwitch from './ToggleSwitch.vue'

export default {
  name: 'CustomAttributes',
  components: { ToggleSwitch },
  emits: ['updated'],
  props: {
    resourceId: { type: String, default: null },
    module: { type: String, default: 'schedules' }
  },

  data() {
    return {
      fields: []
    }
  },

  async mounted() {
    await this.loadFields()
  },

  methods: {
    async loadFields() {
      try {
        const params = { module: this.module }
        if (this.resourceId) params.resource_id = this.resourceId
        const res = await api.get('/attributes/fields', { params, silent: true })
        this.fields = res.data?.items || []
        this.emitUpdated()
      } catch { /* silent */ }
    },

    emitUpdated() {
      this.$emit('updated', this.fields.map(f => ({
        _id: f._id,
        code: f.code,
        value: f.value
      })))
    }
  }
}
</script>
